import BaseRequest from '../_baseRequest';

const baseUrl = 'Report';

const GlossaryService = {
  glossary: () => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      {},
      null,
      'get',
      '/api/' + baseUrl + '/Glossario',
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  }
};

export default GlossaryService;
